import React from "react";
import { useParams, Link } from "react-router-dom";
import styles from "./MarketSketchDetail.module.css";
import marketNewsList from "../../data/marketSketchData"; // 뉴스 데이터 불러오기

const MarketSketchDetail = () => {
  const { newsId } = useParams();
  const news = marketNewsList.find((item) => item.id === parseInt(newsId, 10));

  if (!news) {
    return <p className={styles.notFound}>News not found</p>;
  }

  return (
    <section className={styles.detailContainer}>
      <Link to="/marketSketch" className={styles.backButton}>
        ← Back to Market Sketch
      </Link>
      <h2 className={styles.title}>{news.title}</h2>
      <p className={styles.meta}>
        {news.author} | {news.date}
      </p>
      {/* HTML 태그 적용 */}
      <div
        className={styles.content}
        dangerouslySetInnerHTML={{ __html: news.content }}
      />
    </section>
  );
};

export default MarketSketchDetail;
